import { render, staticRenderFns } from "./CreateEventTotal.vue?vue&type=template&id=24945a2e&scoped=true"
import script from "./CreateEventTotal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEventTotal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateEventTotal.vue?vue&type=style&index=0&id=24945a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24945a2e",
  null
  
)

export default component.exports